// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MQmYM","toggle":"styles_toggle__2LdGT","preview":"styles_preview__3jf24"};